import { CREDITS } from "@card-data/credits";
import { schemas } from "@card-data/generated/api.client";

import { DISCONTINUED_OFFERS } from "../placeholder-offers";
import { CreditCardInput } from "../types";

export const US_BANK_CARDS: Array<CreditCardInput> = [
  {
    cardId: "3d777bda73262fa43b11626eb383f9ab",
    name: "Business Altitude Power",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.US_BANK,
    isBusiness: true,
    annualFee: 195,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/business-banking/business-credit-cards/business-altitude-power-world-elite-mastercard.html",
    imageUrl: "/images/usbank/altitude-power.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 10_000,
        days: 120,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 10_000,
        days: 120,
        credits: [],
      },
    ],
  },
  {
    cardId: "1e6ddb097a524ce3b68719ae6c5eb1e8",
    name: "Business Altitude Connect",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.US_BANK,
    isBusiness: true,
    annualFee: 95,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/business-banking/business-credit-cards/business-altitude-connect-world-elite-mastercard.html",
    imageUrl: "/images/usbank/business-altitude-connect.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 6000,
        days: 180,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 6000,
        days: 180,
        credits: [],
      },
    ],
  },
  {
    cardId: "9a35bfe5845f7f9909244b1e3549b7e1",
    name: "Altitude Connect",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.US_BANK,
    isBusiness: false,
    annualFee: 0,
    details: "Points cannot be transferred and have ~0.8cpp value.",
    isAnnualFeeWaived: true,
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/credit-cards/altitude-connect-visa-signature-credit-card.html",
    imageUrl: "/images/usbank/altitude-connect.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 20_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 1000,
        days: 90,
        credits: [],
        expiration: "2026-07-24",
      },
      {
        amount: [{ amount: 20_000 }],
        spend: 1000,
        days: 90,
        credits: [],
        expiration: "2026-04-04",
      },
      {
        amount: [{ amount: 30_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "f81e751b8d46af2e7c84cc4cf4083dec",
    name: "Altitude Reserve",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.US_BANK,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 2,
    url: "https://www.nerdwallet.com/article/credit-cards/u-s-bank-altitude-reserve-closed-to-new-applications",
    imageUrl: "/images/usbank/altitude-reserve.png",
    discontinued: true,
    credits: [],
    offers: [
      // Card is being phased out; needs to stay here so people can still enter it under "My Cards"
    ],
    historicalOffers: [],
  },
  {
    cardId: "b523a3cc7d6d355737b1c4dda1eb7a04",
    name: "Altitude Go",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.US_BANK,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    details: "Points cannot be transferred, so are valued at 1cpp.",
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/credit-cards/altitude-go-visa-signature-credit-card.html",
    imageUrl: "/images/usbank/altitude-go.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 20_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 1000,
        days: 120,
        credits: [],
      },
    ],
  },
  {
    cardId: "78726438553c1f6b63383f3bac6df57b",
    name: "Cash+",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/credit-cards/cash-plus-visa-signature-credit-card.html",
    imageUrl: "/images/usbank/cash-plus.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 250 }],
        spend: 1000,
        credits: [],
        days: 90,
      },
    ],
  },
  {
    cardId: "6ad6818a9b47a8e42efd29440616e249",
    name: "FlexPerks Gold",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.AMERICAN_EXPRESS,
    currency: schemas.CurrenciesEnum.enum.US_BANK,
    isBusiness: false,
    annualFee: 85,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/credit-cards/flexperks-gold-american-express-credit-card.html",
    imageUrl: "/images/usbank/flexperks-gold.jpg",
    credits: [],
    offers: [
      // no bonus at the moment
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 2000,
        days: 120,
        credits: [],
      },
    ],
    discontinued: true,
  },
  {
    cardId: "4899141df2aa46191c192c6f216b74cf",
    name: "Business Leverage",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: true,
    annualFee: 95,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1,
    url: "https://www.usbank.com/business-banking/business-credit-cards/business-leverage-rewards-credit-card.html",
    imageUrl: "/images/usbank/business-leverage.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 750, currency: "USD" }],
        spend: 7_500,
        days: 120,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 900 }],
        spend: 7500,
        credits: [],
        days: 120,
      },
    ],
  },
  {
    cardId: "a9fe40efecc22039a980c039bb6841be",
    name: "Business Triple Cash Rewards",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: true,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.usbank.com/business-banking/business-credit-cards/business-triple-cash-back-credit-card.html",
    imageUrl: "/images/usbank/business-triple-cash-rewards.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 750 }],
        spend: 6000,
        days: 180,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 750 }],
        spend: 4500,
        days: 150,
        credits: [],
        expiration: "2026-02-01",
      },
      {
        amount: [{ amount: 750 }],
        spend: 6000,
        days: 150,
        credits: [],
      },
    ],
  },
  {
    cardId: "90d9bd31d33bc6cfbdb1eb0962cbce57",
    name: "Skypass Blue",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.KOREAN,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.skypassvisa.com/credit/visaSkyBlueCard.do",
    imageUrl: "/images/usbank/skypass.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 10_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 10_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "824f4be5b9f38164fb8f44522467876e",
    name: "Skypass",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.KOREAN,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.skypassvisa.com/credit/visaSignatureCard.do",
    imageUrl: "/images/usbank/skypass.png",
    credits: [
      {
        value: 50,
        description: "$50 Korean Air credit",
        weight: 0.8,
      },
    ],
    offers: [
      {
        amount: [{ amount: 40_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 40_000 }],
        spend: 4000,
        days: 90,
        credits: [],
        url: "https://www.skypassvisa.com/credit/visaSignatureCard.do",
      },
    ],
  },
  {
    cardId: "aceef720d7ec6cf06ee46865fc39d612",
    name: "Skypass Select",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.KOREAN,
    isBusiness: false,
    annualFee: 450,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.skypassvisa.com/credit/visaSelectCard.do",
    imageUrl: "/images/usbank/skypass-select.png",
    credits: [
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        value: 200,
        description: "$200 travel credit",
        weight: 0.8,
      },
      {
        value: 50,
        description: "Korean Air credit",
        weight: 0.8,
      },
    ],
    offers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "cf146925642ec392eee6c924cfc7ec0d",
    name: "Skypass Business",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.KOREAN,
    isBusiness: true,
    annualFee: 99,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.skypassvisa.com/credit/visaBusinessCard.do",
    imageUrl: "/images/usbank/skypass-business.png",
    credits: [
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        value: 50,
        description: "Korean Air credit",
        weight: 0.8,
      },
    ],
    offers: [
      {
        amount: [{ amount: 50_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 50_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "8de694e89b9c26c9f72fc7450c66665b",
    name: "Shopper Cash Rewards",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1.5,
    url: "https://www.usbank.com/credit-cards/shopper-cash-rewards-visa-signature-credit-card.html",
    imageUrl: "/images/usbank/shopper-cash-rewards.webp",
    credits: [],
    discontinued: true,
    offers: DISCONTINUED_OFFERS,
    historicalOffers: [
      {
        amount: [{ amount: 250 }],
        spend: 2000,
        days: 120,
        credits: [],
        expiration: "2026-06-22",
      },
      {
        amount: [{ amount: 300 }],
        spend: 2000,
        days: 120,
        credits: [],
      },
    ],
  },
  {
    cardId: "e1679e714c2139ed85bd250e229ded16",
    name: "Smartly",
    issuer: schemas.IssuersEnum.enum.US_BANK,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 2,
    url: "https://www.usbank.com/credit-cards/bank-smartly-visa-signature-credit-card.html",
    imageUrl: "/images/usbank/smartly.webp",
    credits: [],

    discontinued: true,
    offers: DISCONTINUED_OFFERS,
    historicalOffers: DISCONTINUED_OFFERS,
  },
];
